import React, { useEffect, useState } from "react";
import Layout from "../../layouts/Layout";
import ProcurementForm from "./forms/specifications";
import { useNavigate } from "react-router-dom";

export default function Create() {
  const navigate = useNavigate();
  const [procurement, setProcurement] = useState();

  useEffect(() => {
    if (procurement?.uuid) {
      navigate(`/procurement/${procurement.uuid}`);
    }
  // eslint-disable-next-line
  }, [procurement]);

  return (
    <Layout>
      <ProcurementForm setProcurement={setProcurement} />
    </Layout>
  );
}
